require('./login-header.global.pcss');

export const loginHeaderComponent =  {
  templateUrl: require('./login-header.html'),
};